import React, { useEffect, useState } from 'react';
import ProductCard from '../Components/Products/ProductCard';
import NavBar from '../Components/Main/NavBar';
import Footer from '../Components/Main/Footer';
import '../css/Products/Products.css';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { SpinningCircles } from 'react-loading-icons'
import { useContext } from 'react';
import { AuthContext } from '../Context/AuthProvider';
import prestigeImg from '../Assets/prestige.jpg';
import refineImg from '../Assets/refine.png';
import sogevaImg from '../Assets/sogeva.jpeg';
import buschImg from '../Assets/busch.jpg';

const CompanyProducts = () => {
  const [products,setProducts]=useState()
  const {company} = useParams();
  const { user } = useContext(AuthContext);
  const [image,setImage]=useState();
  
  useEffect(() => {
  if (company === "Prestige") {
    setImage(prestigeImg);
  } else if (company === "Refine") {
    setImage(refineImg);
  } else if (company === "Sogeva") {
    setImage(sogevaImg);
  } else if (company === "Busch") {
    setImage(buschImg);
  }
}, [company]);

  useEffect(() => {
    const API=process.env.REACT_APP_BACKEND_URL
    const fetchProducts= async () => {
      try {
        const params = {
        ...(company && { company }),
        ...(user?.id && { account_id: user.id }),
};
        const response = await axios.get(`${API}/companyproducts`, {
          params
        });
        setProducts(response.data);
      } catch (error) {
        console.log(error)
      }
    }
    fetchProducts()
  },[company]);
  return (
    <div className='product-site'>
      <NavBar />
      <div className='products-category-title'>
        {company ? (<h1>{company}</h1>) : (<></>)}
        {company ? (<img src={image} alt={company}/>) : (<></>)}
      </div>
      <div className="products-container">
        {products ? (
          products.map((product, index) => (
            <ProductCard key={index} product={product}/>
          ))
        ) : (
          <div>
            <SpinningCircles />
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default CompanyProducts;